/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  options: { label: string; prompt: string }[];
  disabled?: boolean;
  onSelect: (prompt: string) => void;
}

interface QuickResponsesSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiMessagesQuickResponsesComponent =
  templateOnly<QuickResponsesSignature>();

export default UiMessagesQuickResponsesComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Messages::QuickResponses': typeof UiMessagesQuickResponsesComponent;
  }
}
